export const fieldStyle = {
  width: '100%',
  '& .MuiInputBase-root': {
    borderRadius: '10px',
    fontSize: '14px',
    height: '2.5rem',
    width: 'auto',
  },
}
